const formats = {
  video: ["mp4", "webm", "mov"],
  audio: ["mp3", "wav"],
  word: ["doc", "docx", "txt", "dot"],
  pdf: ["pdf"],
  ppt: ["ppt", "pptx"],
  zip: ["zip", "rar"],
  image: ["png", "jpeg", "jpg", "svg", "gif", "heic"],
  url: ["url"],
  xlsx: ["xlsx", "csv", "xls"],
};

export default formats;
